export default {
    GET_PROFIL: (state) => state.profil,
};